import { render, staticRenderFns } from "./JobsPage.vue?vue&type=template&id=706f1e88&scoped=true&"
import script from "./JobsPage.vue?vue&type=script&lang=js&"
export * from "./JobsPage.vue?vue&type=script&lang=js&"
import style0 from "./JobsPage.vue?vue&type=style&index=0&id=706f1e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f1e88",
  null
  
)

export default component.exports